import React from 'react'
import ReactDOM from 'react-dom/client'
import V08 from '../dip_dashboard_v_1_5' // your file at project root

const root = document.getElementById('root')!
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <V08 />
  </React.StrictMode>
)
